import Vue from 'vue'
import Router from 'vue-router'
import VueRouter from 'vue-router'
import Main from '@/components/Main'
import Login from '@/components/Login'
import Chart from '@/components/Chart'
import PatientInfo from '@/components/PatientInfo'


Vue.use(Router)
Vue.use(VueRouter)
const router = new Router({

  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      props: true,
      beforeEnter: (to, from, next) => {
        //  if not auth go to Login
        if (!router.app.$session.exists("authenticated")) next({name: 'Login'})
        else next() // else enter route
      }
    },
    {
      path: "/Login",
      name: "Login",
      component: Login,
    },
    {
      path: "/data",
      name: "Chart",
      component: Chart
    },
    {
      path: "/patientInfo",
      name: "PatientInfo",
      component: PatientInfo,
      props: true
    }
  ]
})

router.afterEach((to, from) => {

});

export default router




// WEBPACK FOOTER //
// ./src/router/index.js